import { Info } from 'lucide-react';
import { useState } from 'react';

interface MetricCardProps {
  label: string;
  value: string | number;
  sublabel?: string;
  tooltip?: string;
  highlight?: boolean;
  warning?: boolean;
}

export default function MetricCard({ label, value, sublabel, tooltip, highlight, warning }: MetricCardProps) {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      className={`relative rounded-lg border p-4 ${
        warning
          ? 'border-cyan-500/30 bg-cyan-950/20'
          : highlight
          ? 'border-cyan-500/30 bg-navy-900/50'
          : 'border-gray-700/50 bg-navy-950/50'
      }`}
    >
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs font-medium text-gray-400 uppercase tracking-wider">{label}</span>
        {tooltip && (
          <div className="relative">
            <Info
              size={14}
              className="text-gray-500 hover:text-gray-300 cursor-help"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            />
            {showTooltip && (
              <div className="absolute right-0 top-6 z-50 w-56 rounded-md bg-gray-800 border border-gray-600 p-2 text-xs text-gray-300 shadow-lg">
                {tooltip}
              </div>
            )}
          </div>
        )}
      </div>
      <div className={`text-2xl font-bold ${warning ? 'text-cyan-400' : highlight ? 'text-cyan-400' : 'text-white'}`}>
        {value}
      </div>
      {sublabel && <div className="text-xs text-gray-500 mt-1">{sublabel}</div>}
    </div>
  );
}
